import { atom, useAtom, useAtomValue } from 'jotai';

export const translateMode = atom(true);

export const useTranslateMode = () => {
  return useAtom(translateMode);
};

export const useTranslateModeValue = () => {
  return useAtomValue(translateMode);
};
